var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17 3H7v3h10zM6 3v3H4.5A2.5 2.5 0 0 0 2 8.5v7A2.5 2.5 0 0 0 4.5 18H6v2.5A1.5 1.5 0 0 0 7.5 22h9a1.5 1.5 0 0 0 1.5-1.5V18h1.5a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 19.5 6H18V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1m12 14h1.5a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 19.5 7h-15A1.5 1.5 0 0 0 3 8.5v7A1.5 1.5 0 0 0 4.5 17H6v-2H5a.5.5 0 0 1 0-1h14a.5.5 0 0 1 0 1h-1zM7 20.5V15h10v5.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5M8.5 16a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zM8 18.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M5 8H4v1h1z",
    clipRule: "evenodd"
  })));
});
const SvgPrint = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrint);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNyAzSDdWNkgxN1YzWk02IDNWNkg0LjVDMy4xMTkyOSA2IDIgNy4xMTkyOSAyIDguNVYxNS41QzIgMTYuODgwNyAzLjExOTI5IDE4IDQuNSAxOEg2VjIwLjVDNiAyMS4zMjg0IDYuNjcxNTcgMjIgNy41IDIySDE2LjVDMTcuMzI4NCAyMiAxOCAyMS4zMjg0IDE4IDIwLjVWMThIMTkuNUMyMC44ODA3IDE4IDIyIDE2Ljg4MDcgMjIgMTUuNVY4LjVDMjIgNy4xMTkyOSAyMC44ODA3IDYgMTkuNSA2SDE4VjNDMTggMi40NDc3MiAxNy41NTIzIDIgMTcgMkg3QzYuNDQ3NzIgMiA2IDIuNDQ3NzIgNiAzWk0xOCAxN0gxOS41QzIwLjMyODQgMTcgMjEgMTYuMzI4NCAyMSAxNS41VjguNUMyMSA3LjY3MTU3IDIwLjMyODQgNyAxOS41IDdIMThIMTdIN0g2SDQuNUMzLjY3MTU3IDcgMyA3LjY3MTU3IDMgOC41VjE1LjVDMyAxNi4zMjg0IDMuNjcxNTcgMTcgNC41IDE3SDZWMTVINUM0LjcyMzg2IDE1IDQuNSAxNC43NzYxIDQuNSAxNC41QzQuNSAxNC4yMjM5IDQuNzIzODYgMTQgNSAxNEgxOUMxOS4yNzYxIDE0IDE5LjUgMTQuMjIzOSAxOS41IDE0LjVDMTkuNSAxNC43NzYxIDE5LjI3NjEgMTUgMTkgMTVIMThWMTdaTTcgMjAuNVYxNUgxN1YyMC41QzE3IDIwLjc3NjEgMTYuNzc2MSAyMSAxNi41IDIxSDcuNUM3LjIyMzg2IDIxIDcgMjAuNzc2MSA3IDIwLjVaTTguNSAxNkM4LjIyMzg2IDE2IDggMTYuMjIzOSA4IDE2LjVDOCAxNi43NzYxIDguMjIzODYgMTcgOC41IDE3SDE1LjVDMTUuNzc2MSAxNyAxNiAxNi43NzYxIDE2IDE2LjVDMTYgMTYuMjIzOSAxNS43NzYxIDE2IDE1LjUgMTZIOC41Wk04IDE4LjVDOCAxOC4yMjM5IDguMjIzODYgMTggOC41IDE4SDEyLjVDMTIuNzc2MSAxOCAxMyAxOC4yMjM5IDEzIDE4LjVDMTMgMTguNzc2MSAxMi43NzYxIDE5IDEyLjUgMTlIOC41QzguMjIzODYgMTkgOCAxOC43NzYxIDggMTguNVpNNSA4SDRWOUg1VjhaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";